import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import Translate from '../common/Translate';
import ProgressCircle from './ProgressCircle';

const SectionButton = ({ formId, sectionId, progress, lastQuestion }) => {
  let link = `/forms/${formId}/${sectionId}`;
  if (lastQuestion !== null && typeof lastQuestion === 'string') link = `${link}/${lastQuestion}`;

  return (
    <Link className="section-button" to={link}>
      <div className="d-flex" data-cy={sectionId}>
        <div className="align-self-center">
          <ProgressCircle progress={progress} />
        </div>
        <div className="align-self-center ml-4">
          <Translate code={sectionId} />
        </div>
      </div>
    </Link>
  );
};

export default SectionButton;

SectionButton.propTypes = {
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  progress: PropTypes.number,
  lastQuestion: PropTypes.string,
};

SectionButton.defaultProps = {
  progress: undefined,
  lastQuestion: null,
};
